module.exports = __webpack_public_path__ + "img/RadialGutter.7d4496c4.svg";